<div class="help-text" (click)="clickToCall();openDrawer('callpopup')" *ngIf="displayNeedHelpText">
    <img class="call-us-icon" src="assets/img/svg/Icon awesome-phone.svg" alt="need help"> Need Help?
</div>
<!-- Need help drawer -->
<app-drawer [isModal]="true" class="call-popup" [drawerId]="'callpopup'" [width]="'half'" [backdropDisable]="true">
  <div class="popup-container">
  <div class="close-icon-popup">
    <img (click)="hideDrawer('callpopup')" src="assets/img/svg/close.svg" alt="close-icon">
  </div>
  <h5 class="text-center thankyou-msg-popup">Stay tuned for our call</h5>
  <h5 class="text-center help-text-popup cb-1">Your journey will be guided by our expert!</h5>
  <div class="text-center call-img-popup">
    <img src="assets/img/svg/thankYouImage.svg" height="50%" width="50%" alt="thankyou header">
  </div>
  <div class="text-center msg-2-popup">
    Thank you for showing your interest
  </div>
  <div class="text-center msg-explore cb-1">
    Click on explore button to see more curated offers for you
  </div>
  <div>
    <button (click)="onExplore()" class="btn btn-primary btnconfirm btn-single width-tr"
      type="button">
      EXPLORE
    </button>
  </div>
</div>
</app-drawer>
